import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DifficultyBadge',
  props: {
    difficulty: {}
  },
  setup(__props: any) {

const props = __props;

const difficultyClass = computed(() => {
  switch (props.difficulty?.toUpperCase()) {
    case 'EASY':
      return 'difficulty-easy';
    case 'MEDIUM':
      return 'difficulty-medium';
    case 'HARD':
      return 'difficulty-hard';
    default:
      return 'difficulty-hard';
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass([difficultyClass.value, "difficulty-badge"])
  }, _toDisplayString(_ctx.difficulty), 3))
}
}

})